import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deleteJob, getJobs, JobSummary } from '../services/adminApi';

const JobsPage = () => {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState<JobSummary[]>([]);
  const [error, setError] = useState<string | null>(null);

  const loadJobs = async () => {
    setError(null);
    try {
      const items = await getJobs();
      setJobs(items);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('pages.jobsLoadFailed', 'Failed to load jobs.'));
    }
  };

  useEffect(() => {
    void loadJobs();
  }, []);

  const handleDelete = async (id: string) => {
    if (!confirm(t('pages.jobsDeleteConfirm', 'Delete this job?'))) return;
    try {
      await deleteJob(id);
      await loadJobs();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('pages.jobsDeleteFailed', 'Delete failed'));
    }
  };

  return (
    <div className="page-grid">
      <div className="section-heading">
        <h2>{t('pages.jobsTitle')}</h2>
        <p>{t('pages.jobsDescription')}</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="admin-panel">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0 }}>{t('pages.jobsTitle')}</h3>
          <Link to="/admin/jobs/new" className="btn btn-primary">
            {t('pages.jobsNew', 'New job')}
          </Link>
        </div>

        <div style={{ display: 'grid', gap: '1rem', marginTop: '1rem' }}>
          {jobs.map((job) => (
            <div key={job.id} className="admin-panel" style={{ padding: '1rem' }}>
              <h4 style={{ margin: 0 }}>{job.title}</h4>
              <p style={{ margin: '0.25rem 0', color: '#475569' }}>{job.location}</p>
              <p style={{ margin: '0.25rem 0', fontWeight: 600 }}>{job.isOpen ? t('pages.jobsOpen') : t('pages.jobsClosed')}</p>
              <div className="admin-actions" style={{ marginTop: '1rem' }}>
                <Link to={`/admin/jobs/${job.id}`} className="btn btn-secondary">
                  {t('common.edit', 'Edit')}
                </Link>
                <button type="button" className="btn btn-ghost" onClick={() => handleDelete(job.id)}>
                  {t('common.delete', 'Delete')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobsPage;
